import styled from 'styled-components';
import { Section, SubSection } from 'styles/cards';
import colors, { opacity } from 'styles/colors';
import { fontWeight } from 'styles/common';
import { ModalContent } from 'styles/modals';
import { Divider } from '../FleetSettings.styles';

export const GeofencingSection = styled(Section)`
  height: fit-content;
`;

export const MapContainer = styled.div`
  width: 100%;
  border: 1px solid ${colors.gray80};
`;

export const MapContent = styled.div`
  height: 375px;
  width: 585px;
`;

export const TypeWrapper = styled.div`
  position: relative;
`;

export const TypeContainer = styled.div`
  position: absolute;
  bottom: 22px;
  left: 80px;
`;

export const TypeTabContainer = styled.div<{ visible?: boolean }>`
  border: 1px solid ${colors.gray60};
  border-radius: 1px;
  height: 35px;
  width: 100px;
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  margin-top: 5px;
`;

export const TabItem = styled.div<{ active?: boolean }>`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 20px;
  color: ${colors.gray60};
  transition: 0.15s background-color ease-in-out;

  &:first-child {
    border-right: 1px solid ${colors.gray60};
  }

  &:hover {
    background-color: ${colors.gray80};
  }

  ${(props) =>
    props.active
      ? `
            background-color: ${colors.gray80};
        `
      : null};
`;

export const GeofencingModalContent = styled(ModalContent)`
  padding: 16px 32px;
`;

export const GeofencingModalSection = styled.div<{ emptyState?: boolean }>`
  padding: 0px 24px 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.emptyState ? 'center' : 'flex-start')};
  margin-bottom: ${(props) => (props.emptyState ? '32px' : 'none')};
`;

export const EmptyGeofencingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 32px;
`;

export const MarginedDivider = styled(Divider)`
  margin: 16px 0;
`;

export const StyledSlider = styled.div<{ $position: number }>`
  position: absolute;
  width: calc(100% / 2);
  height: inherit;
  background-color: ${colors.white};
  border-radius: inherit;
  box-shadow: 0 1px 4px 0 ${opacity(colors.black, 0.15)};
  border: 1px ${colors.fleetOffGray} solid;
  z-index: 0;
  left: ${(props) => `calc(100% / 2  * ${props.$position})`};
  margin-left: -1px;

  transition: left 200ms ease-in-out;
`;

export const StyledLabel = styled.label<{ $checked: boolean; $disabled?: any }>`
  cursor: pointer;
  text-transform: uppercase;
  font-weight: ${fontWeight.semibold};
  z-index: 1;
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
  color: ${colors.fleetDarkGray};

  ${({ $checked }) => $checked && `color: ${colors.fleetBlue};`}
  ${({ $disabled }) => $disabled && `color: ${colors.gray40}; cursor: not-allowed;`} // Disable styles

  &:hover {
    ${({ $disabled }) => !$disabled && `color: ${colors.fleetBlue};`}
  }
`;

export const SlidingRadioInput = styled.div`
  box-sizing: content-box;
  margin-top: 8px;
  border-radius: 16px;
  border: 1px ${colors.fleetOffGray} solid;
  background-color: ${colors.metricsHoverBackground};
  height: 30px;
  align-items: center;
  justify-content: space-evenly;
  position: relative;
  display: flex;
`;

export const SliderContainer = styled.div`
  width: 240px;
`;

export const SpinnerSubSection = styled(SubSection)`
  height: 120px;
  margin-top: 24px;
`;
